/* eslint-disable import/no-relative-packages */
import { ActionPerformed } from '@capacitor/push-notifications';
import { Style } from '@capacitor/status-bar';
import { IExpedient, IExpedientSeguiments } from 'bg-server/src/components/api/v1/expedient/types';
import { IForm } from 'bg-server/src/components/api/v1/form/types';
import { INotificationData } from 'bg-server/src/components/api/v1/push/notification/types';
import { ITramitPopulated } from 'bg-server/src/components/api/v1/tramit/types';
import { IUser } from 'bg-server/src/components/api/v1/user/types';

export enum EAppTheme {
    'Mobile', 'Web', 'Glasses', 'Transparent',
}

export interface IUserMessage {
    isError: boolean;
    text: string;
}

export interface IUserState {
    isLoggingIn?: boolean;
    isLoggedIn?: boolean;
    isLoggedInVerified?: boolean;
    isSettingsUpdating?: boolean;
    user?: IUser;
    deepLinkEmail?: string;
    message?: IUserMessage;
    currentRequestId?: string;
    isLoading: boolean;
}

export interface IExpedientState {
    selectedExpedient: IExpedient;
    selectedExpedientWithSeguiments: IExpedientSeguiments;
    isLoading: boolean;
    isAttachmentProcessing: boolean;
}

export interface ITramitState {
    selectedTramit: ITramitPopulated;
    isLoading: boolean;
    isAttachmentProcessing: boolean;
}

export interface IFormState {
    documents: IForm[];
    districtes: string[];
    isLoading: boolean;
}

export interface IAdressState {
    districtes: string[];
    barris: string[];
    codiPostals: string[];
    isLoaded: boolean;
    isLoading: boolean;
}

export interface IAppState {
    title: string;
    loading: boolean;
    style: Style;
    error: string;
    theme: EAppTheme;
    selectedCity: string;
    lastActionStatus: string;
    selectedMenu: string;
    screenSize: 'mobile' | 'tablet' | 'desktop';
}

export interface IPushState {
    actions: ActionPerformed[];
    notifications: INotificationData[];
    currentRequestId?: string;
}

// This interface represents app state by nesting feature states.
export interface ICoreState {
    app: IAppState;
    user?: IUserState;
    push: IPushState;
    expedient: IExpedientState;
    tramit: ITramitState;
}
